module.exports = __webpack_public_path__ + "static/Advantage03@2x.8e4787fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage03@2x.png
// module id = 690
// module chunks = 216210090109534